import { HttpContext, HttpContextToken, HttpRequest } from '@angular/common/http';
import { IHttpContext } from './model';

export const DEFAULT_HTTP_CONTEXT: IHttpContext = {
  loader: true,
  gateway: true,
  profile: true,
  skipProfileUpdate: false
};

export const HTTP_CONTEXT = new HttpContextToken<IHttpContext>(() => DEFAULT_HTTP_CONTEXT);

export class ContextBuilder {
  private _context: IHttpContext;

  constructor() {
    this._context = DEFAULT_HTTP_CONTEXT;
    return this;
  }

  static getContext(request: HttpRequest<unknown>): IHttpContext {
    return request.context.get(HTTP_CONTEXT);
  }

  build(): HttpContext {
    const newContext = new HttpContext();
    newContext.set<IHttpContext>(HTTP_CONTEXT, this._context);
    return newContext;
  }

  append<T = Partial<IHttpContext>>(context: T): ContextBuilder {
    this._context = { ...this._context, ...context };
    return this;
  }

  /**
   * preset contexts
   **/
  disableLoader(): ContextBuilder {
    return this.append({ loader: false });
  }
  enableLoader(): ContextBuilder {
    return this.append({ loader: true });
  }

  omitGateway(): ContextBuilder {
    return this.append({ gateway: false });
  }

  omitProcessProfile(): ContextBuilder {
    return this.append({ profile: false });
  }

  skipProfileUpdate(): ContextBuilder {
    return this.append({ skipProfileUpdate: true });
  }
}
